import { LoomSiteAri } from '@atlassian/ari/loom/site';
import { getATLContextUrl } from '@atlassian/atl-context';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useEnvironment } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';

export const useLoomCrossJoinUrl = () => {
	const cloudId = useCloudId();
	const env = useEnvironment();
	const continueUrl =
		env === 'prod'
			? 'https://loom.com/api/auth/atlassian'
			: 'https://stage.loom.com/api/auth/atlassian';
	const identityDomain = getATLContextUrl('id');
	const userAccessUrl = `${identityDomain}/join/user-access?${new URLSearchParams({
		resource: LoomSiteAri.create({ siteId: cloudId }).toString(),
		continue: continueUrl,
	}).toString()}`;

	return `${identityDomain}/login?${new URLSearchParams({
		continue: userAccessUrl,
	}).toString()}`;
};
